import React from "react";
import { Drawer, IconButton, Typography, Box, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import colors from "../../../../Constants/colors";

const APIKeySideBar = ({ open_sidebar, set_open_sidebar }) => {
  //   const cmd = `curl -X POST https://app.queryloop.ai/api/developer/use/ -H "Content-Type: application/json" -H "apiKey: {YOUR_API_KEY}" -d "{\\"query\\": \\"What is this about?\\"}"`;

  const handleCloseSidebar = () => {
    set_open_sidebar(false);
  };

  return (
    <Drawer anchor="right" open={open_sidebar} onClose={handleCloseSidebar}>
      <Box
        sx={{
          width: 750,
          padding: 2,
          backgroundColor: colors.extremeBlue,
          // height: "100%",
          color: colors.extremeWhite,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">API Key Interface</Typography>
          <IconButton
            onClick={handleCloseSidebar}
            sx={{ color: colors.extremeWhite }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box
          mt={2}
          mb={2}
          sx={{
            display: "flex",
            flexDirection: "column", // Vertical layout for the Paper components
            gap: 2, // Adds spacing between Paper components
            overflowY: "auto", // Allow vertical scrolling if needed
            scrollbarWidth: "none", // Hide scrollbar in Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar in Chrome/Safari/Edge
            },
          }}
        >
          <Paper
            elevation={4}
            sx={{
              backgroundColor: colors.darkGray, // Darker background for boxes
              padding: 2,
              boxShadow: `0px 4px 12px ${colors.secondaryBlue}`, // Box shadow with secondaryBlue
              fontFamily: "'Courier New', Courier, monospace",
              color: colors.extremeWhite,
            }}
          >
            <Typography
              variant="h6"
              color={colors.extremeWhite}
              sx={{
                fontWeight: "bold",
                paddingBottom: 2,
                mb: 2,
                borderBottom: `1px solid ${colors.extremeWhite}`,
              }}
            >
              How to Use Your API Key
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              <b>1. Introduction:</b>
              <br />
              The API key allows you to interact securely with our platform,
              ensuring that only authorized requests are processed.
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              <b>2. Setting Up Your API Key:</b> <br />
              Your API key can be found by navigating to the{" "}
              <b>
                <code>settings/apiKeys</code>
              </b>{" "}
              URL or by going to the drawer, selecting <b>Settings</b>, and then
              selecting the <b>My Keys</b> tab. Replace{" "}
              <code>{`{YOUR_API_KEY}`}</code> with your actual API key.
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              <b>3. Generating Your User Token:</b> <br />
              You can generate your user token by clicking on this{" "}
              <b>
                <a href="/dashboard/profile">link</a>
              </b>
              , which will navigate you to your user profile. Once there, go to
              the <b>User Token</b> tab to generate your token. Replace{" "}
              <code>{`{YOUR_VERIFICATION_TOKEN}`}</code> with the generated
              token.
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              <b>4. Using the API Key:</b> <br />
              The API key is used in the <code>apiKey</code> header of your API
              requests to authenticate your identity.
            </Typography>
            <Typography variant="body2">
              <b>5. Testing the API Key:</b> <br />
              Use the command below to test your API key:
            </Typography>
            <Paper
              elevation={4}
              sx={{
                backgroundColor: colors.extremeBlue,
                padding: 2,
                mt: 2,
                // boxShadow: `0px 4px 12px ${colors.secondaryBlue}`,
                fontFamily: "'Courier New', Courier, monospace",
                color: colors.extremeWhite,
                mb: 2,
              }}
            >
              <Typography
                variant="subtitle2"
                color={colors.extremeWhite}
                sx={{ whiteSpace: "pre-line", display: "block" }}
              >
                {`MAC Terminal:
                    curl -X POST https://app.queryloop.ai/api/developer/use
                    -H "Content-Type: application/json"
                    -H "apiKey: {YOUR_API_KEY}"
                    -d "{"query": "What is this about?", "verification_token": "{YOUR_VERIFICATION_TOKEN}"}"`}
              </Typography>
            </Paper>
            <Paper
              elevation={4}
              sx={{
                backgroundColor: colors.extremeBlue,
                padding: 2,
                mt: 2,
                // boxShadow: `0px 4px 12px ${colors.secondaryBlue}`,
                fontFamily: "'Courier New', Courier, monospace",
                color: colors.extremeWhite,
                mb: 2,
              }}
            >
              <Typography
                variant="subtitle2"
                color={colors.extremeWhite}
                sx={{ whiteSpace: "pre-line", display: "block" }}
              >
                {`CMD:
                    curl -X POST https://app.queryloop.ai/api/developer/use
                    -H "Content-Type: application/json"
                    -H "apiKey: {YOUR_API_KEY}"
                    -d "{"query": "What is this about?", "verification_token": "{YOUR_VERIFICATION_TOKEN}"}"`}
              </Typography>
            </Paper>
            <Typography variant="subtitle2" sx={{ textAlign: "center", mb: 2 }}>
              Replace <code>{`{YOUR_API_KEY}`}</code> and{" "}
              <code>{`{YOUR_VERIFICATION_TOKEN}`}</code> with your actual API
              key and Verification Token, then run the command in your terminal.
            </Typography>
            <Typography variant="body2">
              <b>5. Security Tip:</b> Store your API key securely. <br />
              If compromised, regenerate a new key through your account
              settings.
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Drawer>
  );
};
export default APIKeySideBar;
